import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    label: translate({ id: 'form.drivers.edit.fields.email.label' }),
    error: {
      inUse: translate({ id: 'form.drivers.edit.errors.email.inUse' }),
      invalid: translate({ id: 'form.drivers.edit.errors.email.invalid' }),
    },

    placeholder: translate({ id: 'form.drivers.edit.fields.email.label' }),
  }))

  return api
}
